import Container from './container'

export default Container



// WEBPACK FOOTER //
// ./src/payments/details/index.js